enum ListViewActions {
    MarkAsUnread = 'MarkAsUnread',
    MarkAsRead = 'MarkAsRead',
    Flag = 'Flag',
    Unflag = 'Unflag',
    Pin = 'Pin',
    Unpin = 'Unpin',
}

export default ListViewActions;
